import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

import './assets/log-in-link.scss';

const LogInLink = (props) => (
  <Link
    onClick={props.toggleMobileMenu}
    data-test-id='log-in-button'
    className='log-in-link-button'
    to='/log-in'
  >
    Log In
  </Link>
);

LogInLink.propTypes = {
  toggleMobileMenu: PropTypes.func
};

export default LogInLink;
